import { render, staticRenderFns } from "./vueDoc.vue?vue&type=template&id=29677a0a&scoped=true"
import script from "./vueDoc.vue?vue&type=script&lang=js"
export * from "./vueDoc.vue?vue&type=script&lang=js"
import style0 from "./vueDoc.vue?vue&type=style&index=0&id=29677a0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29677a0a",
  null
  
)

export default component.exports